module.exports = __webpack_public_path__ + "img/insurance-fund.1e484f94.jpg";